export enum ActionType {
  AssignStaff = 1,
  ManageRecipients = 2,
  SendMessage = 3,
  Close = 4,
}